import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { message } from "antd";

export default function BookingConfirmed() {
  // Getting the booking id from url
  const { bookingId } = useParams();

  // Making the navigation varaible
  const navigate = useNavigate();

  // Making the state to store booking details
  const [bookingData, setBookingData] = useState();

  // Loading State
  const [loading, setLoading] = useState(true);

  // Making the message
  const [messageApi, contextHolder] = message.useMessage();

  // Getting The Bookings Data
  const getBookingData = async () => {
    try {
      const response = await fetch(
        `https://hotelbnb-backend.onrender.com/pending-booking/${bookingId}`
      );

      if (response.ok) {
        const result = await response.json();
        setBookingData({
          room_img: result?.room_img,
          booking_holder_name: result?.booking_holder_name,
          booking_holder_email: result?.booking_holder_email,
          booking_from: result?.booking_from,
          booking_to: result?.booking_to,
          booking_hotel: result?.booking_hotel,
          booking_room_number: result?.booking_room_number,
          booking_room_price: result?.booking_room_price,
          booking_total: result?.booking_total,
          booking_status: "Active",
        });

        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Setting the Booking Confirmed Message
  const bookingConfirmedAlert = () => {
    messageApi.open({
      type: "success",
      content: "Booking Confirmed",
      duration: 2,
    });
  };

  // Setting the Booking Not Confirmed Message
  const bookingNotConfirmedAlert = () => {
    messageApi.open({
      type: "error",
      content: "Booking Confirmation Error",
      duration: 2,
    });
  };

  // Creating The Active Booking
  const createActiveBooking = async (e) => {
    const response = await fetch(
      `https://hotelbnb-backend.onrender.com/add-bookings-toDb`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bookingData),
      }
    );
    const result = await response.json();

    if (response.ok) {
      bookingConfirmedAlert();
      deletingBookingFromPendingBookings();
    } else if (!response.ok) {
      bookingNotConfirmedAlert();
      setTimeout(() => {
        navigate("/my-bookings");
      }, 2500);
    }
  };

  // Checking if booking data is set and loading is false so we can update
  const checkBookingData = () => {
    if (!loading && bookingData) {
      createActiveBooking();
    }
  };

  useEffect(() => {
    checkBookingData();
  }, [loading]);

  // Deleting The Booking From Pending Bookings
  const deletingBookingFromPendingBookings = async () => {
    if (bookingData) {
      const response = await fetch(
        `https://hotelbnb-backend.onrender.com/delete-pending-booking/${bookingId}`,
        {
          method: "DELETE",
        }
      );
      if (response.ok) {
        setTimeout(() => {
        navigate("/my-bookings");
      }, 2500);
      }
    }
  };

  useEffect(() => {
    getBookingData();
  }, []);

  
  return (
    <>
      {contextHolder}
      <div class="d-flex flex-column gap-2 justify-content-center align-items-center booking-confirmation">
        <div class="spinner-grow" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p>Booking Confirmation</p>
      </div>
    </>
  );
}
